// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ItemDetail } from '@/items/api/types';
import { initializeFieldSelections } from '@/items/components/merge-item/utilities/merge-utilities';
import { useState } from 'react';

interface UseFieldSelectionsResult {
  fieldSelections: Record<string, 'primary' | 'selected'>;
  setFieldSelections: React.Dispatch<
    React.SetStateAction<Record<string, 'primary' | 'selected'>>
  >;
  handleFieldSelectionChange: (
    field: string,
    source: 'primary' | 'selected'
  ) => void;
  initializeSelections: (
    primaryItem: ItemDetail,
    selectedItem: ItemDetail
  ) => void;
  resetSelections: () => void;
}

export function useFieldSelections(): UseFieldSelectionsResult {
  const [fieldSelections, setFieldSelections] = useState<
    Record<string, 'primary' | 'selected'>
  >({});

  const handleFieldSelectionChange = (
    field: string,
    source: 'primary' | 'selected'
  ) => {
    setFieldSelections((prev) => ({
      ...prev,
      [field]: source,
    }));
  };

  const initializeSelections = (
    primaryItem: ItemDetail,
    selectedItem: ItemDetail
  ) => {
    const initialSelections = initializeFieldSelections(
      primaryItem,
      selectedItem
    );
    setFieldSelections(initialSelections);
  };

  const resetSelections = () => {
    setFieldSelections({});
  };

  return {
    fieldSelections,
    setFieldSelections,
    handleFieldSelectionChange,
    initializeSelections,
    resetSelections,
  };
}
